module.exports = __webpack_public_path__ + "05_mustache_brown.17b30807.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/05_mustache_brown.png
// module id = QdBR
// module chunks = 0